
export interface ApiErrorResponse {
    message: string;
    errorDetails: string;
    links: { [key: string]: string };
    nextStepToken: string;
}

export function isDuesCalculationFailedResponse(data?: ApiErrorResponse): boolean {
    return data?.links?.duesCalculationFailed === 'true';
}

export function createApiErrorResponse(obj?: ApiErrorResponse | any) {
    const result = <ApiErrorResponse>{
        errorDetails: '',
        links: {},
        message: '',
        nextStepToken: ''
    };

    if (obj) {
        Object.assign(result, obj);
    }
    return result;
}